export default __webpack_public_path__ + "static/media/right-icon.f64ac8ee.svg";